import { isBundledMobileApp } from '@/mobile/native/apiBase';
import type { FieldSyncUserSnapshot } from '@/mobile/sync/fieldSyncTypes';

export async function applyFieldSyncUserSnapshot(
  user: FieldSyncUserSnapshot | undefined,
): Promise<void> {
  if (!user?.id || !isBundledMobileApp()) {
    return;
  }

  const { syncBundledAuthUserFromServer } = await import('@/mobile/native/bundledAuthPage');
  await syncBundledAuthUserFromServer(user);
}
